import { getDefaultState } from './constants.js';

export default {
  SET_ADD_A_DONATION(state, addADonation) {
    state.addADonation = { ...addADonation };
  },

  RESET_ADD_A_DONATION(state, addADonation) {
    state.addADonation = addADonation
      ? { ...addADonation }
      : { ...getDefaultState().addADonation };
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};
